import React from "react"
import avatar from "avatar/vigo-sad.svg"

const VigoSad = (props) => <img src={avatar} className="avatar" {...props} />

export default VigoSad
